import React from 'react'

import { NOOP } from 'constants/commonConstans'

import RichTextFormFonts from './RichTextFormFont'
import type { RichTextFormBrandType, RichTextBrandForms } from './richTextTypes'

const FORM_MAP: RichTextBrandForms = {
  ...RichTextFormFonts,
}

const RichTextFormBrand: RichTextFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(RichTextFormBrand) as typeof RichTextFormBrand
